const INITIAL_SETUP_KEY = 'foodstation:initial-setup-pending';

const getRestaurantId = (session) => (
  session?.restaurante_id
  || session?.restauranteId
  || session?.restaurant?.id
  || session?.user?.restaurante_id
  || session?.user?.restauranteId
  || null
);

export const markInitialSetupPending = (session) => {
  if (typeof window === 'undefined') return;
  const restaurantId = getRestaurantId(session);
  window.localStorage.setItem(INITIAL_SETUP_KEY, String(restaurantId || 'pending'));
};

export const isInitialSetupPending = (session) => {
  if (typeof window === 'undefined') return false;
  const pendingRestaurantId = window.localStorage.getItem(INITIAL_SETUP_KEY);
  if (!pendingRestaurantId) return false;
  const restaurantId = getRestaurantId(session);
  return !restaurantId
    || pendingRestaurantId === 'pending'
    || pendingRestaurantId === String(restaurantId);
};

export const completeInitialSetup = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(INITIAL_SETUP_KEY);
};

